import { AuthorisedApolloProvider } from '@/components/auth-components/AuthorisedApolloProvider'
import { UpdatePasswordModal } from '@/components/auth-components/UpdatePasswordModal'
import { CommandKBar } from '@/components/layout-components/CommandKBar'
import { CorePageProgress } from '@/components/layout-components/CorePageProgress'
import { AccessProfileProvider } from '@/context/accessProfileContext'
import { AnalyticsProvider } from '@/context/analytics'
import { BuildPassAuthProvider } from '@/context/authContext'
import { BreadcrumbProvider } from '@/context/breadcrumbContext'
import { CommandKBarProvider } from '@/context/commandKBarContext'
import { FilterProvider } from '@/context/filterContext'
import { MentionInputProvider } from '@/context/mentionInputContext'
import { NavigationProvider } from '@/context/navigationContext'
import { PreventSavingProvider } from '@/context/preventSavingContext'
import { ProjectProvider } from '@/context/projectContext'
import { BuilderSubscriptionProvider } from '@/context/subscriptionContext'
import { SupportProvider } from '@/context/supportContext'
import { SwitchBuilderModalProvider } from '@/context/switchBuilderContext'
import { TimezoneProvider } from '@/context/timezoneContext'
import { UserProvider } from '@/context/userContext'
import { ExpiredTrialLayout } from '@/layouts/ExpiredTrialLayout'
import SwitchBuilderModal from '@/modules/superAdmin/SaSwitchBuilderModal'

type Props = {
  children?: React.ReactNode
}

export const AuthenticatedLayout: React.FC<Props> = ({ children }) => {
  return (
    <BuildPassAuthProvider>
      <AuthorisedApolloProvider>
        <AnalyticsProvider>
          <UserProvider>
            <BuilderSubscriptionProvider>
              <AccessProfileProvider>
                <ExpiredTrialLayout>
                  <ProjectProvider>
                    <NavigationProvider>
                      <TimezoneProvider>
                        <FilterProvider>
                          <BreadcrumbProvider>
                            <PreventSavingProvider>
                              <SupportProvider>
                                <MentionInputProvider>
                                  <CorePageProgress />
                                  <SwitchBuilderModalProvider>
                                    <CommandKBarProvider>
                                      {children}
                                      <CommandKBar />
                                      <SwitchBuilderModal />
                                      <UpdatePasswordModal />
                                    </CommandKBarProvider>
                                  </SwitchBuilderModalProvider>
                                </MentionInputProvider>
                              </SupportProvider>
                            </PreventSavingProvider>
                          </BreadcrumbProvider>
                        </FilterProvider>
                      </TimezoneProvider>
                    </NavigationProvider>
                  </ProjectProvider>
                </ExpiredTrialLayout>
              </AccessProfileProvider>
            </BuilderSubscriptionProvider>
          </UserProvider>
        </AnalyticsProvider>
      </AuthorisedApolloProvider>
    </BuildPassAuthProvider>
  )
}
